import React, { useEffect } from 'react';
import { RxCross1 } from "react-icons/rx";
import LogutIcon from '../../assets/images/logutpopup.png'
import './LogoutPopup.css'
import ButtonDahbaord from 'components/ButtonDahbaord/ButtonDahbaord';
function LogoutPopup({ isOpen, onClose, data ,onLogout}) {
    useEffect(() => {
        // Handle clicks outside of the modal content
        const handleClickOutside = (event) => {
          if (event.target.classList.contains('modal-overlay')) {
            onClose();
          }
        };
    
        if (isOpen) {
          document.addEventListener('click', handleClickOutside);
        }
    
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, [isOpen, onClose]);
    
      return (
        <div className={`modal-overlay ${isOpen ? 'open' : 'close'}`}>
          <div id='classname-id-modal' className={`modal-content ${isOpen ? 'slide-in' : 'slide-out'}`}>
          <div className='row-modal-popup margin-bottom' >
          <h2 className='h2-heading-main-mai'>Logout</h2>
            <button onClick={onClose} className="close-button"><RxCross1/></button>
          </div>
          <div className="modal-body" style={{display:'flex',justifyContent:'center'}}>
           <img src={LogutIcon} alt="Logout Icon" className="image-logout" />
          
         </div>
         <h2 className='are-logout-btn'>Are you sure you want to log out?</h2>
            <div className="modal-footer-logut">
            <ButtonDahbaord handleclick={onClose} textButton='Cancel' height={35} width={85} />
           <ButtonDahbaord  handleclick={onLogout} textButton='Logout' height={35} width={85} background='purple' />
         </div>
            {/* Add more details as needed */}
          </div>
        </div>
      );
    }

export default LogoutPopup;
